module.exports = __webpack_public_path__ + "media/slot-game/pie-50b32201.svg";